










































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SearchResultEmpty from '@/components/atoms/SearchResultEmpty.vue';
import SearchResultItem from '@/components/molecules/SearchResultItem.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { ID, ProductMenu } from '@/types/type';

@Component({
  components: {
    SearchResultItem,
    SearchResultEmpty,
  },
})
export default class SearchResultBody extends Vue {
  @Prop()
  private screenLoading!: boolean;

  @Prop()
  private searchLoading!: boolean;

  @Prop()
  private queryText!: string;

  @Prop()
  private searchResult!: ProductMenu[];

  @Prop()
  private searchTime!: number;

  private get literals() {
    return {
      searchMessage: this.screenLoading ? '' : i18n.tc('appbar.searchMessage'),
      notFound: this.screenLoading ? '' : i18n.tc('search.notFound'),
      results: this.screenLoading ? '' : i18n.tc('search.results'),
      disableDueToNotInHouse: this.screenLoading
        ? ''
        : i18n.tc('portal.disableDueToNotInHouse'),
      // seconds: this.screenLoading ? '' : i18n.tc('search.seconds'),
    };
  }

  private get language(): boolean {
    return loginUserModule.userInfo.language;
  }

  private get useFavorite(): boolean {
    return loginUserModule.userInfo.useFavoritePanel;
  }

  private get resultSummary(): string {
    // return `${this.searchResult.length} ${this.literals.results} (
    //   ${this.searchTime / 1000} ${this.literals.seconds} )`;
    return `${this.searchResult.length} ${this.literals.results}`;
  }

  @Emit('click-menu')
  private clickMenu(menu: ProductMenu): ProductMenu {
    return menu;
  }

  @Emit('add-favorite')
  private addFavorite(menu: ProductMenu): void {}

  @Emit('remove-favorite')
  private remveFavorite(id: ID): void {}
}
